import React from "react";

import { TruckOutlined } from "@ant-design/icons";

const addiotionLaods = {
  1: "Полная погрузка",
  2: "Догруз",
};

const Type = ({ order }) => {
  return (
    <div className="order-item__section order-item__type">
      <div className="order-item__section__icon">
        <TruckOutlined
          style={{
            fontSize: 20,
            color: "#333",
          }}
        />
      </div>
      {order.item.additional_load == 1 && (
        <div className="order-item__section__content">
          {order.item.count_of_transport
            ? `${order.item.count_of_transport} авто`
            : ""}
          &nbsp;
          {order.item.volume}м3&nbsp;{order.item.weight} тонн.
        </div>
      )}
      {order.item.additional_load == 2 && (
        <div className="order-item__section__content">
          {addiotionLaods[order.item.additional_load]}&nbsp;
          {order.item.volume}м3&nbsp;{order.item.weight} тонн.
        </div>
      )}
    </div>
  );
};

export default Type;
